export default "__VITE_ASSET__2yvENPNW__"